package co.uk.sacursoftware.ssinventory

import androidx.compose.runtime.*
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import co.uk.sacursoftware.ssinventory.util.KeyValueStorage
import co.uk.sacursoftware.ssinventory.util.UserRole

private const val WEB_ROLE_KEY = "web_user_role"

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport {
        val storage = remember { KeyValueStorage() }
        var activeRole by remember {
            mutableStateOf(
                storage.getString(WEB_ROLE_KEY)
                    ?.let { runCatching { UserRole.valueOf(it) }.getOrNull() }
                    ?: UserRole.SHOP
            )
        }

        App(
            userRole = activeRole,
            onUserRoleChange = { role ->
                activeRole = role
                storage.putString(WEB_ROLE_KEY, role.name)
            }
        )
    }
}
